import React from 'react'

import { Helmet } from 'react-helmet'

import './approach.css'

const Approach = (props) => {
  return (
    <div className="approach-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="approach-approach">
        <div className="approach-frame121">
          <div className="approach-frame15">
            <div className="approach-frame162">
              <img
                alt="VectorI372"
                src="/external/vectori372-vfl5.svg"
                className="approach-vector10"
              />
              <span className="approach-text10">futureheirs</span>
            </div>
            <div className="approach-frame81">
              <div className="approach-frame6">
                <span className="approach-text11">Home</span>
              </div>
              <div className="approach-frame7">
                <span className="approach-text12">About Us</span>
              </div>
              <div className="approach-frame82">
                <span className="approach-text13">Contact Us</span>
              </div>
              <div className="approach-frame9">
                <span className="approach-text14">Blog</span>
              </div>
            </div>
            <div className="approach-component41">
              <span className="approach-text15">Join Us</span>
            </div>
          </div>
          <div className="approach-frame132">
            <div className="approach-frame195">
              <img
                alt="Line652161"
                src="/external/line652161-zmse.svg"
                className="approach-line65"
              />
              <span className="approach-text16">Our Approach</span>
            </div>
            <span className="approach-text17">
              Discover how our faith-driven, tech-focused, and
              community-centered approach empowers students for lifelong
              learning and purpose.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle42161"
          src="/external/rectangle42161-ktn8.svg"
          className="approach-rectangle4"
        />
        <div className="approach-frame244">
          <div className="approach-frame2161">
            <span className="approach-text18">
              A Holistic Approach to Transformative Learning
            </span>
            <span className="approach-text19">
              At FutureHeirs, we blend faith, technology, and community to
              empower students with purpose-driven education.
            </span>
          </div>
          <div className="approach-frame2411">
            <div className="approach-frame239">
              <div className="approach-frame2381">
                <img
                  alt="Rectangle112219"
                  src="/external/rectangle112219-ianp-500w.png"
                  className="approach-rectangle111"
                />
                <div className="approach-frame2371"></div>
              </div>
              <div className="approach-frame2361">
                <div className="approach-frame2181">
                  <span className="approach-text20">
                    Faith-Integrated Learning
                  </span>
                  <span className="approach-text21">
                    We believe that true education addresses the whole person.
                    Our curriculum integrates biblical principles with academic
                    excellence, helping students develop not just knowledge and
                    skills, but wisdom and discernment.
                  </span>
                </div>
                <div className="approach-frame2351">
                  <span className="approach-text22">What We Do:</span>
                  <div className="approach-group1251">
                    <span className="approach-text23">
                      Integrate biblical principles with academic subjects.
                    </span>
                    <span className="approach-text24">
                      Encourage wisdom and ethical decision-making.
                    </span>
                    <span className="approach-text25">
                      Help students connect faith with their personal and
                      academic growth.
                    </span>
                    <img
                      alt="Ellipse92219"
                      src="/external/ellipse92219-aw7r-200h.png"
                      className="approach-ellipse91"
                    />
                    <img
                      alt="Ellipse122219"
                      src="/external/ellipse122219-3rns-200h.png"
                      className="approach-ellipse121"
                    />
                    <img
                      alt="Ellipse132219"
                      src="/external/ellipse132219-ftqe-200h.png"
                      className="approach-ellipse131"
                    />
                    <img
                      alt="Line672219"
                      src="/external/line672219-hrhc.svg"
                      className="approach-line671"
                    />
                    <img
                      alt="Line682219"
                      src="/external/line682219-8vm.svg"
                      className="approach-line681"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="approach-frame240">
              <div className="approach-frame2362">
                <div className="approach-frame2182">
                  <span className="approach-text26">Technology as a Tool</span>
                  <span className="approach-text27">
                    In today&apos;s digital world, technological literacy is
                    essential. We equip students with both fundamental and
                    advanced tech skills, teaching them to be not just consumers
                    but creators and ethical innovators in the digital space.
                  </span>
                </div>
                <div className="approach-frame2352">
                  <span className="approach-text28">What We Do:</span>
                  <div className="approach-group1252">
                    <span className="approach-text29">
                      Teach coding, digital design, and emerging technologies.
                    </span>
                    <span className="approach-text30">
                      Focus on ethical innovation and responsible tech use.
                    </span>
                    <span className="approach-text31">
                      Prepare students for future careers in a digital-first
                      world.
                    </span>
                    <img
                      alt="Ellipse92211"
                      src="/external/ellipse92211-mswqh-200h.png"
                      className="approach-ellipse92"
                    />
                    <img
                      alt="Ellipse122211"
                      src="/external/ellipse122211-e1if-200h.png"
                      className="approach-ellipse122"
                    />
                    <img
                      alt="Ellipse132211"
                      src="/external/ellipse132211-fg53-200h.png"
                      className="approach-ellipse132"
                    />
                    <img
                      alt="Line672211"
                      src="/external/line672211-01bp.svg"
                      className="approach-line672"
                    />
                    <img
                      alt="Line682211"
                      src="/external/line682211-zi1.svg"
                      className="approach-line682"
                    />
                  </div>
                </div>
              </div>
              <div className="approach-frame2382">
                <img
                  alt="Rectangle112219"
                  src="/external/rectangle112219-qh-500w.png"
                  className="approach-rectangle112"
                />
                <div className="approach-frame2372"></div>
              </div>
            </div>
            <div className="approach-frame2412">
              <div className="approach-frame2383">
                <img
                  alt="Rectangle112211"
                  src="/external/rectangle112211-shg6-500w.png"
                  className="approach-rectangle113"
                />
                <div className="approach-frame2373"></div>
              </div>
              <div className="approach-frame2363">
                <div className="approach-frame2183">
                  <span className="approach-text32">
                    Community-Centered Development
                  </span>
                  <span className="approach-text33">
                    No child thrives in isolation. Our programs foster
                    supportive communities where peers learn together, mentors
                    guide growth, and families are engaged in the educational
                    journey.
                  </span>
                </div>
                <div className="approach-frame2353">
                  <span className="approach-text34">What We Do:</span>
                  <div className="approach-group1253">
                    <span className="approach-text35">
                      Create mentorship programs with peer and leader support.
                    </span>
                    <span className="approach-text36">
                      Establish learning hubs in underserved communities.
                    </span>
                    <span className="approach-text37">
                      Engage families in the educational journey for holistic
                      growth.
                    </span>
                    <img
                      alt="Ellipse92211"
                      src="/external/ellipse92211-8ool-200h.png"
                      className="approach-ellipse93"
                    />
                    <img
                      alt="Ellipse122211"
                      src="/external/ellipse122211-jqdo-200h.png"
                      className="approach-ellipse123"
                    />
                    <img
                      alt="Ellipse132211"
                      src="/external/ellipse132211-wk5-200h.png"
                      className="approach-ellipse133"
                    />
                    <img
                      alt="Line672211"
                      src="/external/line672211-h6gi.svg"
                      className="approach-line673"
                    />
                    <img
                      alt="Line682211"
                      src="/external/line682211-u9po.svg"
                      className="approach-line683"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="approach-frame242">
              <div className="approach-frame2364">
                <div className="approach-frame2184">
                  <span className="approach-text38">
                    Purpose-Driven Education
                  </span>
                  <span className="approach-text39">
                    Every course, project, and activity is designed to help
                    students discover their unique purpose. We believe education
                    should prepare children not just for careers, but for
                    callings.
                  </span>
                </div>
                <div className="approach-frame2354">
                  <span className="approach-text40">What We Do:</span>
                  <div className="approach-group1254">
                    <span className="approach-text41">
                      Guide students in identifying their strengths and
                      passions.
                    </span>
                    <span className="approach-text42">
                      Encourage leadership and service through real-world
                      projects.
                    </span>
                    <span className="approach-text43">
                      Instill confidence in students to pursue meaningful
                      careers and callings.
                    </span>
                    <img
                      alt="Ellipse92211"
                      src="/external/ellipse92211-xv4s-200h.png"
                      className="approach-ellipse94"
                    />
                    <img
                      alt="Ellipse122211"
                      src="/external/ellipse122211-mc0n-200h.png"
                      className="approach-ellipse124"
                    />
                    <img
                      alt="Ellipse132211"
                      src="/external/ellipse132211-5dw3-200h.png"
                      className="approach-ellipse134"
                    />
                    <img
                      alt="Line672211"
                      src="/external/line672211-m9b5.svg"
                      className="approach-line674"
                    />
                    <img
                      alt="Line682211"
                      src="/external/line682211-7r8t.svg"
                      className="approach-line684"
                    />
                  </div>
                </div>
              </div>
              <div className="approach-frame2384">
                <img
                  alt="Rectangle112211"
                  src="/external/rectangle112211-y0ll-500w.png"
                  className="approach-rectangle114"
                />
                <div className="approach-frame2374"></div>
              </div>
            </div>
            <div className="approach-frame245">
              <div className="approach-frame2162">
                <div className="approach-frame231">
                  <div className="approach-frame232">
                    <span className="approach-text44">
                      Join Our Mission in Transformative Learning
                    </span>
                    <span className="approach-text45">
                      Experience an education that empowers students with faith,
                      technology, and purpose.
                    </span>
                  </div>
                  <div className="approach-frame233">
                    <div className="approach-component42">
                      <span className="approach-text46">Get Involved</span>
                    </div>
                    <span className="approach-text47">
                      Explore Our Programs
                    </span>
                  </div>
                </div>
              </div>
              <div className="approach-frame247">
                <div className="approach-frame2185">
                  <span className="approach-text48">What Our Client Says</span>
                  <span className="approach-text49">
                    Real experiences, real impact. Here&apos;s what our clients
                    have to say about working with us.
                  </span>
                </div>
                <div className="approach-component7">
                  <div className="approach-frame146">
                    <div className="approach-frame1341">
                      <div className="approach-frame153">
                        <div className="approach-frame1591">
                          <img
                            alt="Ellipse5I258"
                            src="/external/ellipse5i258-f2jd-200w.png"
                            className="approach-ellipse5"
                          />
                          <div className="approach-frame1521">
                            <span className="approach-text50">Michael</span>
                            <span className="approach-text51">
                              Program Graduate
                            </span>
                          </div>
                        </div>
                        <div className="approach-vuesaxboldquotedown1">
                          <div className="approach-vuesaxboldquotedown2">
                            <div className="approach-quotedown1">
                              <img
                                alt="VectorI258"
                                src="/external/vectori258-k41m.svg"
                                className="approach-vector11"
                              />
                              <img
                                alt="VectorI258"
                                src="/external/vectori258-gmr9.svg"
                                className="approach-vector12"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="approach-text52">
                        FutureHeirs didn&apos;t just teach me coding—they showed
                        me how to use my skills to serve others. Now I&apos;m
                        building apps that help my community access resources
                        they need.
                      </span>
                    </div>
                    <div className="approach-frame148">
                      <div className="approach-frame1541">
                        <div className="approach-frame1592">
                          <img
                            alt="Ellipse6I258"
                            src="/external/ellipse6i258-ethi-200w.png"
                            className="approach-ellipse61"
                          />
                          <div className="approach-frame1522">
                            <span className="approach-text53">Sarah</span>
                            <span className="approach-text54">
                              Scholarship Recipient
                            </span>
                          </div>
                        </div>
                        <div className="approach-vuesaxboldquotedown3">
                          <div className="approach-vuesaxboldquotedown4">
                            <div className="approach-quotedown2">
                              <img
                                alt="VectorI258"
                                src="/external/vectori258-8str.svg"
                                className="approach-vector13"
                              />
                              <img
                                alt="VectorI258"
                                src="/external/vectori258-x7oj.svg"
                                className="approach-vector14"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="approach-text55">
                        The mentors at FutureHeirs helped me see how my faith
                        and my passion for science could work together. I&apos;m
                        now studying biomedical engineering with a vision to
                        bring healthcare solutions to underserved areas.
                      </span>
                    </div>
                    <div className="approach-frame151">
                      <div className="approach-frame1542">
                        <div className="approach-frame1593">
                          <img
                            alt="Ellipse6I258"
                            src="/external/ellipse6i258-vf8u-200w.png"
                            className="approach-ellipse62"
                          />
                          <div className="approach-frame1523">
                            <span className="approach-text56">Gabriel</span>
                            <span className="approach-text57">
                              Program Graduate
                            </span>
                          </div>
                        </div>
                        <div className="approach-vuesaxboldquotedown5">
                          <div className="approach-vuesaxboldquotedown6">
                            <div className="approach-quotedown3"></div>
                          </div>
                        </div>
                      </div>
                      <span className="approach-text58">
                        FutureHeirs didn&apos;t just teach me coding—they showed
                        me how to use my skills to serve others. Now I&apos;m
                        building apps that help my community access resources
                        they need.
                      </span>
                    </div>
                  </div>
                  <img
                    alt="Rectangle6I258"
                    src="/external/rectangle6i258-ssb-300w.png"
                    className="approach-rectangle6"
                  />
                  <img
                    alt="Frame109I258"
                    src="/external/frame109i258-dg8.svg"
                    className="approach-frame1091"
                  />
                  <div className="approach-component43">
                    <span className="approach-text59">View more</span>
                  </div>
                </div>
              </div>
              <div className="approach-component5">
                <div className="approach-frame140">
                  <span className="approach-text60">Our Programs</span>
                  <div className="approach-frame131">
                    <img
                      alt="Frame130I253"
                      src="/external/frame130i253-9we.svg"
                      className="approach-frame130"
                    />
                    <img
                      alt="Frame109I253"
                      src="/external/frame109i253-q2ws.svg"
                      className="approach-frame1092"
                    />
                  </div>
                </div>
                <div className="approach-frame139">
                  <div className="approach-frame135">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-nwf-200h.png"
                      className="approach-rectangle31"
                    />
                    <div className="approach-frame1342">
                      <span className="approach-text61">
                        Online Learning Academy
                      </span>
                      <span className="approach-text62">
                        Our digital platform makes quality, faith-integrated
                        education...
                      </span>
                    </div>
                    <div className="approach-component44">
                      <span className="approach-text63">Learn more</span>
                    </div>
                  </div>
                  <div className="approach-frame138">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-u7f8-200h.png"
                      className="approach-rectangle32"
                    />
                    <div className="approach-frame1343">
                      <span className="approach-text64">
                        Tech Innovation Centers
                      </span>
                      <span className="approach-text65">
                        Hands-on learning spaces where students develop
                        practical...
                      </span>
                    </div>
                    <div className="approach-component45">
                      <span className="approach-text66">Learn more</span>
                    </div>
                  </div>
                  <div className="approach-frame137">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-42oc-200h.png"
                      className="approach-rectangle33"
                    />
                    <div className="approach-frame1344">
                      <span className="approach-text67">
                        Community Learning Hubs
                      </span>
                      <span className="approach-text68">
                        Physical spaces within underserved communities...
                      </span>
                    </div>
                    <div className="approach-component46">
                      <span className="approach-text69">Learn more</span>
                    </div>
                  </div>
                  <div className="approach-frame136">
                    <img
                      alt="Rectangle3I253"
                      src="/external/rectangle3i253-23jk-200h.png"
                      className="approach-rectangle34"
                    />
                    <div className="approach-frame1345">
                      <span className="approach-text70">
                        Leadership Development
                      </span>
                      <span className="approach-text71">
                        Beyond academics and technical skills, we invest in
                        cultivating...
                      </span>
                    </div>
                    <div className="approach-component47">
                      <span className="approach-text72">Learn more</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="approach-frame217">
          <div className="approach-frame190">
            <div className="approach-group39">
              <img
                alt="Rectangle19304"
                src="/external/rectangle19304-kwb-1100w.png"
                className="approach-rectangle1"
              />
              <div className="approach-grid">
                <div className="approach-group34">
                  <img
                    alt="Line519304"
                    src="/external/line519304-pieo.svg"
                    className="approach-line51"
                  />
                  <img
                    alt="Line529304"
                    src="/external/line529304-7e39.svg"
                    className="approach-line52"
                  />
                  <img
                    alt="Line539304"
                    src="/external/line539304-wo3.svg"
                    className="approach-line53"
                  />
                  <img
                    alt="Line549304"
                    src="/external/line549304-nwlf.svg"
                    className="approach-line54"
                  />
                  <img
                    alt="Line559304"
                    src="/external/line559304-abc7.svg"
                    className="approach-line55"
                  />
                  <img
                    alt="Line569304"
                    src="/external/line569304-7ku.svg"
                    className="approach-line56"
                  />
                  <img
                    alt="Line579304"
                    src="/external/line579304-b6el.svg"
                    className="approach-line57"
                  />
                </div>
                <div className="approach-group33">
                  <img
                    alt="Line369304"
                    src="/external/line369304-4eng.svg"
                    className="approach-line36"
                  />
                  <img
                    alt="Line379304"
                    src="/external/line379304-ano9.svg"
                    className="approach-line37"
                  />
                  <img
                    alt="Line389304"
                    src="/external/line389304-ohsi.svg"
                    className="approach-line38"
                  />
                  <img
                    alt="Line399304"
                    src="/external/line399304-oht.svg"
                    className="approach-line39"
                  />
                </div>
              </div>
              <img
                alt="childrenelectronicdevicesgadgetsconceptsmartconfid9304"
                src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid9304-j0r-500h.png"
                className="approach-childrenelectronicdevicesgadgetsconceptsmartconfid"
              />
            </div>
            <div className="approach-frame122">
              <div className="approach-frame133">
                <span className="approach-text73">
                  Subscribe to our Newsletter
                </span>
                <span className="approach-text74">
                  Join our community of supporters and stay updated on how
                  we&apos;re empowering the next generation of leaders.
                </span>
              </div>
              <div className="approach-cta">
                <div className="approach-frame3">
                  <span className="approach-text75">example@gmail.com</span>
                </div>
                <div className="approach-component48">
                  <span className="approach-text76">Subscribe</span>
                </div>
              </div>
            </div>
          </div>
          <div className="approach-frame189">
            <div className="approach-frame184">
              <div className="approach-group107">
                <span className="approach-text77">Company</span>
                <div className="approach-frame2491">
                  <span className="approach-text78">Home</span>
                  <span className="approach-text79">About Us</span>
                  <span className="approach-text80">Contact Us</span>
                  <span className="approach-text81">Programs</span>
                  <span className="approach-text82">Approach</span>
                </div>
              </div>
              <div className="approach-group106">
                <span className="approach-text83">Quick Links</span>
                <div className="approach-frame2492">
                  <span className="approach-text84">Partner with Us</span>
                  <span className="approach-text85">Volunteer</span>
                  <span className="approach-text86">Donate</span>
                  <span className="approach-text87">Blog</span>
                </div>
              </div>
              <div className="approach-group105">
                <span className="approach-text88">Terms and Policies</span>
                <div className="approach-frame248">
                  <span className="approach-text89">Privacy Policy</span>
                  <span className="approach-text90">Terms and Conditions</span>
                  <span className="approach-text91">Feedback</span>
                  <span className="approach-text92">FAQs</span>
                </div>
              </div>
              <div className="approach-group104">
                <span className="approach-text93">Contact Information</span>
                <div className="approach-group87">
                  <span className="approach-text94">
                    connect@futureheirs.org
                  </span>
                  <div className="approach-vuesaxboldsms1">
                    <div className="approach-vuesaxboldsms2">
                      <div className="approach-sms">
                        <img
                          alt="VectorI216"
                          src="/external/vectori216-tbzd.svg"
                          className="approach-vector15"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="approach-group88">
                  <span className="approach-text95">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="approach-vuesaxboldlocation1">
                    <div className="approach-vuesaxboldlocation2">
                      <img
                        alt="VectorI216"
                        src="/external/vectori216-8nhb.svg"
                        className="approach-vector16"
                      />
                    </div>
                  </div>
                </div>
                <div className="approach-group89">
                  <span className="approach-text96">(555) 123-4567</span>
                  <div className="approach-vuesaxboldcall1">
                    <div className="approach-vuesaxboldcall2">
                      <div className="approach-call">
                        <img
                          alt="VectorI216"
                          src="/external/vectori216-19vj.svg"
                          className="approach-vector17"
                        />
                        <img
                          alt="VectorI216"
                          src="/external/vectori216-dcmr.svg"
                          className="approach-vector18"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I216"
              src="/external/line2i216-gw4.svg"
              className="approach-line2"
            />
            <div className="approach-frame183">
              <div className="approach-frame161">
                <img
                  alt="VectorI216"
                  src="/external/vectori216-f6ll.svg"
                  className="approach-vector19"
                />
                <span className="approach-text97">futureheirs</span>
              </div>
              <div className="approach-frame180">
                <span className="approach-text98">Follow Us:</span>
                <div className="approach-frame177">
                  <div className="approach-vuesaxboldfacebook1">
                    <div className="approach-vuesaxboldfacebook2">
                      <div className="approach-facebook">
                        <img
                          alt="VectorI216"
                          src="/external/vectori216-uy2.svg"
                          className="approach-vector20"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI216"
                    src="/external/riinstagramfilli216-aqa6.svg"
                    className="approach-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI216"
                    src="/external/pajamaslinkedini216-1gvg.svg"
                    className="approach-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI216"
                    src="/external/fa6brandssquarextwitteri216-d0u.svg"
                    className="approach-fa6brandssquarextwitter"
                  />
                  <div className="approach-vuesaxboldyoutube1">
                    <div className="approach-vuesaxboldyoutube2">
                      <div className="approach-youtube">
                        <img
                          alt="VectorI216"
                          src="/external/vectori216-kawz.svg"
                          className="approach-vector21"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Approach
